import {TextFieldBase as $b312f2102feb9487$export$d22444a338b6e3c2} from "./TextFieldBase.mjs";
import {useFormProps as $c29c48d4ef19ffc4$export$a6b5be5c6b451665} from "../form/Form.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useTextField as $ifeZ5$useTextField} from "react-aria/useTextField";
import $ifeZ5$react, {forwardRef as $ifeZ5$forwardRef, useRef as $ifeZ5$useRef, useEffect as $ifeZ5$useEffect} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




const $a38b6369fa4dfb49$export$2c73285ae9390cec = /*#__PURE__*/ (0, $ifeZ5$forwardRef)(function TextField(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $c29c48d4ef19ffc4$export$a6b5be5c6b451665)(props);
    let inputRef = (0, $ifeZ5$useRef)(null);
    let result = (0, $ifeZ5$useTextField)(props, inputRef);
    let hasWarned = (0, $ifeZ5$useRef)(false);
    (0, $ifeZ5$useEffect)(()=>{
        if (props.placeholder && !hasWarned.current && process.env.NODE_ENV !== 'production') {
            console.warn('Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/TextField.html#help-text');
            hasWarned.current = true;
        }
    }, [
        props.placeholder
    ]);
    return /*#__PURE__*/ (0, $ifeZ5$react).createElement((0, $b312f2102feb9487$export$d22444a338b6e3c2), {
        ...props,
        ...result,
        ref: ref,
        inputRef: inputRef
    });
});


export {$a38b6369fa4dfb49$export$2c73285ae9390cec as TextField};
//# sourceMappingURL=TextField.mjs.map
